import { actions } from './actions';
import { getters } from "./getters";
import { mutations } from "./mutations";

const state = {
  listUsers : [],
  authenticated : false,
  errorStatus :  "",
  currentUserPass : "",
  sessionLog :  false,
  usersLogged : {},
  currentUser: {},
  envDossier : "Aucune information",
  nomDossier : "Aucune information",
  annonce:""
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}